import BaseModel from '../BaseModel'

class Sap extends BaseModel {
    constructor() {
        super()
        this.apiBase = 'sap'
        this._status = null
    }

    get status() {
        return this._status ? this._status.connected : false
    }

    getStatus() {
        this.reset()
        this._loading = true
        return new Promise((resolve, reject) => {
            try {
                this._client
                    .index(`${this.base}/status`)
                    .then((res) => {
                        this._loaded = true
                        this._status = res
                        return resolve(res)
                    })
                    .finally(() => {
                        this._loading = false
                    })
            } catch (e) {
                return reject(e)
            }
        })
    }

    email(data) {
        this.reset()
        this._loading = true
        return new Promise((resolve, reject) => {
            try {
                this._client
                    .store(`${this.base}/password`, data)
                    .then((res) => {
                        this._loaded = true
                        return resolve(res)
                    })
                    .finally(() => {
                        this._loading = false
                    })
            } catch (e) {
                return reject(e)
            }
        })
    }

    getRedirectUrl() {
        this.reset()
        this._loading = true
        return new Promise((resolve, reject) => {
            try {
                this._client
                    .index(`${this.base}/redirect_url`)
                    .then((res) => {
                        this._loaded = true
                        return resolve(res && res.url ? res.url : res)
                    })
                    .finally(() => {
                        this._loading = false
                    })
            } catch (e) {
                return reject(e)
            }
        })
    }

    authorization(data) {
        this.reset()
        this._loading = true
        return new Promise((resolve, reject) => {
            try {
                this._client
                    .store(`${this.base}/authorization`, data)
                    .then((res) => {
                        this._loaded = true
                        return resolve(res)
                    })
                    .finally(() => {
                        this._loading = false
                    })
            } catch (e) {
                return reject(e)
            }
        })
    }

    disconnect() {
        this.reset()
        this._loading = true
        return new Promise((resolve, reject) => {
            try {
                this._client
                    .destroy(`${this.base}/disconnect`)
                    .then((res) => {
                        this._loaded = true
                        return resolve(res)
                    })
                    .finally(() => {
                        this._loading = false
                    })
            } catch (e) {
                return reject(e)
            }
        })
    }
}

export { Sap }
